import { Center, Flex, Box, CenterProps, Button } from "@chakra-ui/react";
import { AccountInfo, AccountInfoProps } from "./account-info";
import { CallToAction, SecondaryCta } from "./call-to-action";
import { Threads } from "./threads";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import { layerStyle } from "theme/names";

interface Props {
  account: AccountInfoProps;
  secondaryCta?: SecondaryCta;
  tweets: any[];
  editMode?: boolean;
  mainContainerProps?: CenterProps;
  isLoadingThreads?: boolean;
  onDelete?: (id: string) => void;
  onAdd?: () => void;
  page?: number;
  hasMore?: boolean;
  onNext?: () => void;
  onPrev?: () => void;
}

export function Profile({
  account,
  secondaryCta,
  tweets = [],
  editMode = false,
  mainContainerProps = {},
  isLoadingThreads = false,
  onDelete,
  onAdd,
  page = 1,
  hasMore = false,
  onNext = () => {},
  onPrev = () => {},
}: Props) {
  let prevProps: any = {},
    nextProps = {};

  if (!editMode) {
    prevProps = {
      as: "a",
      href: "/thread-finder/" + account?.username + "?page=" + (page - 1),
    };
    nextProps = {
      as: "a",
      href: "/thread-finder/" + account?.username + "?page=" + (page + 1),
    };
  }

  const threadsUI = (
    <Box ml={{ base: 0, md: 0 }} layerStyle={layerStyle["bg.border.rounded"]} w="full" p="6">
      <Threads
        editMode={editMode}
        tweets={tweets}
        isLoading={isLoadingThreads}
        onDelete={onDelete}
        onAdd={onAdd}
      />
      <Flex justifyContent={page > 1 ? "space-between" : "flex-end"} pt={10}>
        {page > 1 && (
          <Button
            leftIcon={<FiArrowLeft size="16" />}
            variant="tertiaryNoBackground"
            onClick={onPrev}
            {...prevProps}
          >
            Previous
          </Button>
        )}
        {hasMore && page && (
          <Button
            rightIcon={<FiArrowRight size="16" />}
            variant="tertiaryNoBackground"
            onClick={onNext}
            {...nextProps}
          >
            Next
          </Button>
        )}
      </Flex>
    </Box>
  );
  return (
    <Center
      maxW="1200px"
      w="100%"
      flexDir={{ base: "column", md: "row" }}
      alignItems="flex-start"
    gap="12"
      {...mainContainerProps}
    >
      <Flex w="full" flexDir="column" pb="20" marginX={{ base: "auto", md: "flex-start" }}>
        <AccountInfo {...account} editMode={editMode} />
        <CallToAction
          secondaryCta={secondaryCta}
          username={account.username}
          editMode={editMode}
          id_str={account.id_str}
        />
      </Flex>
      {editMode ? threadsUI : tweets?.length > 0 ? threadsUI : null}
    </Center>
  );
}
